module.exports = __webpack_public_path__ + "img/20200515_162509.414caad6.jpg";